import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { "txt-center": "" }
const _hoisted_2 = { "txt-center": "" }
const _hoisted_3 = { class: "App-Ent-Standing-Cols" }
const _hoisted_4 = { class: "Ent-Stand-Lbls" }
const _hoisted_5 = { class: "Ent-Stand-Lbl" }
const _hoisted_6 = {
  key: 0,
  class: "Ent-Stand-Lbl-Self"
}
const _hoisted_7 = { class: "Ent-Stand-Lbl" }
const _hoisted_8 = {
  key: 0,
  class: "Ent-Stand-Lbl-Other"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["App-Ent-Standing", `${_ctx.$filters.capitalize(_ctx.size)} ${_ctx.standingSelf ? 'Loaded' : ''}`])
  }, [
    _createVNode(_component_el_skeleton, {
      style: _normalizeStyle({ width: _ctx.width, maxWidth: '100%', minHeight: _ctx.height, margin: 'auto' }),
      loading: !_ctx.standingSelf,
      animated: ""
    }, {
      template: _withCtx(() => [
        _createVNode(_component_el_space, { class: "App-Ent-Standing-Cols" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
              return (_openBlock(), _createBlock(_component_el_skeleton_item, {
                key: `col-stand-load-${col}`,
                variant: "h2",
                style: _normalizeStyle({
              width: `26px`,
              height: `${_ctx.calculateHeight(_ctx.loadingStanding[col], _ctx.colHeight)}px`,
            })
              }, null, 8, ["style"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("h4", {
            "txt-center": "",
            class: "App-Ent-Standing-T"
          }, " Entrepreneurial Dimensions ", -1)),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_link, {
              target: "_blank",
              href: _ctx.glossary
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("small", null, " How can this help me?", -1)
              ]))]),
              _: 1
            }, 8, ["href"])
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_space, {
            size: _ctx.space,
            class: "App-Ent-Standing-Cols"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `col-standing-${col}`,
                  class: "App-Ent-Standing-Col",
                  style: _normalizeStyle({
                height: `${_ctx.calculateHeight(_ctx.maxCol, _ctx.colHeight) + 10}px`,
              })
                }, [
                  _createElementVNode("div", {
                    class: "App-Ent-Stand-Color App-Ent-Standing-Base",
                    style: _normalizeStyle({
                  height: `${_ctx.calculateHeight(_ctx.maxCol, _ctx.colHeight)}px`,
                })
                  }, _toDisplayString(_ctx.maxCol), 5),
                  (_ctx.standingOther !== undefined)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        content: `${_ctx.$filters.capitalize(_ctx.fullColName(col))} ${
                  _ctx.standingOther[col]
                }`
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: _normalizeClass(["App-Ent-Stand-Color App-Ent-Standing-Other", 
                    _ctx.standingOther[col] < _ctx.standingSelf[col]
                      ? 'App-Ent-Stan-Raised'
                      : ''
                  ]),
                            style: _normalizeStyle({
                    height: `${_ctx.calculateHeight(
                      _ctx.standingOther[col],
                      _ctx.colHeight
                    )}px`,
                  })
                          }, _toDisplayString(_ctx.standingOther[col]), 7)
                        ]),
                        _: 2
                      }, 1032, ["content"]))
                    : _createCommentVNode("", true),
                  (_ctx.standingSelf)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 1,
                        content: `${_ctx.$filters.capitalize(_ctx.fullColName(col))} ${
                  _ctx.standingSelf[col]
                }`
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "App-Ent-Stand-Color App-Ent-Standing-Self",
                            style: _normalizeStyle({
                    height: `${_ctx.calculateHeight(
                      _ctx.standingSelf[col],
                      _ctx.colHeight
                    )}px`,
                  })
                          }, _toDisplayString(_ctx.standingSelf[col]), 5)
                        ]),
                        _: 2
                      }, 1032, ["content"]))
                    : _createCommentVNode("", true)
                ], 4))
              }), 128))
            ]),
            _: 1
          }, 8, ["size"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.labelSelf)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "Ent-Lbl-Dot" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.labelSelf), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.labelOther)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "Ent-Lbl-Dot" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.labelOther), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["style", "loading"])
  ], 2))
}